import { useTranslation } from 'react-i18next'
import { Badge, BadgeProps } from 'ui/components/Badge'
import { FC } from 'react'

export const ReadOnlyBadge: FC = () => {
  const { t } = useTranslation()

  return (
    <div className="mb-4 flex justify-end">
      <Badge label={t('badge.read_only')} variant="info" />
    </div>
  )
}

export const ArchivedBadge: FC = () => {
  const { t } = useTranslation()

  return <Badge label={t('badge.archived')} variant="danger" />
}

export const CancelledBadge: FC = () => {
  const { t } = useTranslation()

  return <Badge label={t('badge.cancelled')} variant="danger" />
}

export const RequiredBadge: FC = () => {
  const { t } = useTranslation()

  return <Badge label={t('badge.required')} variant="default" />
}

export const PrivateBadge: FC = () => {
  const { t } = useTranslation()

  return <Badge label={t('badge.private')} variant="warning" />
}

export const PublicBadge: FC = () => {
  const { t } = useTranslation()

  return <Badge label={t('badge.public')} variant="info" />
}

export const MembersBadge: FC = () => {
  const { t } = useTranslation()

  return <Badge label={t('badge.members')} variant="warning" />
}

export const ExpiredBadge: FC = () => {
  const { t } = useTranslation()

  return <Badge label={t('badge.expired')} variant="danger" />
}

export const GrantedBadge: FC = () => {
  const { t } = useTranslation()

  return <Badge label={t('badge.granted')} variant="success" />
}

export const DeniedBadge: FC<Omit<BadgeProps, 'label' | 'variant'>> = (props) => {
  const { t } = useTranslation()

  return <Badge {...props} label={t('badge.denied')} variant="danger" />
}
